import AppContext from "PFApp/app_context";
import FiltersBox from "PFApp/components/filters/filters_box";
import FiltersButton from "PFApp/components/filters/filters_button";
import FiltersPreview from "PFApp/components/filters/filters_preview";
import { ProfileItem } from "PFApp/components/profile_item";
import AutoSelect from "PFComponents/select/autoselect";
import { fetchProfilesOptions } from "PFCore/services/profile";
import { Avatar, ProfileBasicInformation } from "PFTypes";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import QuickDateFilter from "../bookings_reports/quick_date_filter";
import css from "./filters_bar.module.scss";

type Planner = {
  id: number;
  avatar: Avatar;
  email: string;
  text: string;
  job_title: string;
};

const FiltersBar = () => {
  const {
    store: {
      pages: {
        insights: { tab, insightsMeta, handleFilterChange, handleFiltersReset, noFiltersSelected }
      },
      currentProfile
    }
  } = useContext(AppContext);

  const { t } = useTranslation("insights");

  const [filtersOpen, setFiltersOpen] = useState(false);
  const [planner, setPlanner] = useState<Planner | null>(null);

  useEffect(() => {
    setPlanner(null);
  }, [tab]);

  const handleResponse = useCallback(
    (response) =>
      response.entries.filter((item) => !planner || planner.id !== item.id).concat(currentProfile),
    []
  );

  const handleFormatOptions = useCallback(
    (item) => ({
      id: item.id,
      displayElement: <ProfileItem profile={item} />,
      item: item
    }),
    []
  );

  const handleChange = (profiles) => {
    handleFilterChange({ name: "profile_id" }, profiles[0]?.id);
    setPlanner(profiles[0]);
  };

  const availabilityFilter = insightsMeta.filters.availability;

  return (
    <>
      <div className={css.filtersWrap}>
        <div className={css.otherFilters}>
          {!!insightsMeta.filters && (
            <div className={css.filtersPreview}>
              <FiltersPreview
                meta={insightsMeta}
                blockedList={tab === "skills" ? ["availability"] : [""]}
                filtersAreClear={noFiltersSelected}
                clearFilters={handleFiltersReset}
                onFilterChange={handleFilterChange}
                onMoreClicked={() => {}}
              />
            </div>
          )}
        </div>
        {availabilityFilter && (
          <QuickDateFilter
            availabilityFilter={availabilityFilter}
            handleFilterChange={handleFilterChange}
            dateRangeMode={"past"}
            className={css.quickDateFilter}
          />
        )}
        <FiltersButton
          filtersShown={filtersOpen}
          filtersAreClear={noFiltersSelected}
          onClick={() => setFiltersOpen(!filtersOpen)}
        />
      </div>

      {filtersOpen && insightsMeta.filters && (
        <div style={{ zIndex: 20 }}>
          <FiltersBox
            meta={insightsMeta}
            handleFilterChange={handleFilterChange}
            clearFilters={handleFiltersReset}
            closeFilters={() => setFiltersOpen(false)}
            blockedList={tab === "skills" ? ["availability"] : [""]}
          />
        </div>
      )}

      {tab === "roles" && (
        <AutoSelect
          label={t("selectAResourcer")}
          displayValues={planner ? <ProfileItem profile={planner as ProfileBasicInformation} /> : null}
          values={planner ? [planner] : null}
          closeOnChange
          multi={false}
          letClear
          query={(term: string) => fetchProfilesOptions({ term })}
          parseResponse={(response) => handleResponse(response)}
          formatOption={(item) => handleFormatOptions(item)}
          handleChange={(profiles) => handleChange(profiles)}
          style={{ padding: "0px 15px 20px 15px" }}
        />
      )}
    </>
  );
};

export default FiltersBar;
